<template>
    <div>
        <ManHourCostDialog
            :machine-process-cost-data="currentMachineProcessCost"
            :is-open="manHourCostDialog"
            @on-close="closeManHourCostDialog"
        />
        <v-dialog
            :value="isOpen"
            max-width="700px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Koszty dla maszyny  <strong>{{ machineData.name }}</strong>
                    </h1>
                </v-card-title>

                <v-card-text class="text-center">
                    <v-data-table
                        :items="machine.machineProcessCosts"
                        :headers="headers"
                        disable-pagination
                        hide-default-footer
                        :mobile-breakpoint="0"
                        no-data-text="Nie dodano procesów"
                    >
                        <template #item.process="{item}">
                            {{ item.process.name }}
                        </template>
                        <template #item.manHourCost="{item}">
                            {{ formatPrice(item.manHourCost) }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Edytuj"
                                            v-on="on"
                                            @click="showManHourCostDialog(item)"
                                        >
                                            <v-icon color="teal">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edycja</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Anuluj"
                        @click="onClose"
                    >
                        Anuluj
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import tooltipDelay from '@/mixins/tooltip'
import ManHourCostDialog from './ManHourCostDialog'
import priceFormatter from '@/mixins/priceFormatter'

export default {
    name: 'MachineProcessCostDialog',
    components: {
        ManHourCostDialog
    },
    mixins: [
        tooltipDelay,
        priceFormatter
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        machineData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            machine: {
                productionProcess: []
            },
            currentMachineProcessCost: {
                machineId: null,
                processId: null,
                manHourCost: null
            },
            manHourCostDialog: false,
            actionLoading: false,
            headers: [
                {
                    text: 'Nazwa',
                    value: 'process',
                    sortable: false,
                },
                {
                    text: 'Koszt roboczogodziny (zł)',
                    value: 'manHourCost',
                    sortable: false,
                    align: 'center',
                    width: 150
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.machine = JSON.parse(JSON.stringify(this.machineData))
            }
        },
    },
    methods: {
        showManHourCostDialog(currentMachineProcessCost) {
            this.currentMachineProcessCost = currentMachineProcessCost
            this.manHourCostDialog = true
            this.onClose()
        },
        closeManHourCostDialog() {
            this.manHourCostDialog = false
            this.$emit('show-machine-process-dialog', this.machine.id)
        },
        onClose() {
            setTimeout(() => {
                this.machineProcessCost = null
            }, 500)

            this.$emit('on-close')
        }
    }
}
</script>

